/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 根据文件地址删除文件
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  filePath: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "delete",
    url: `/oss/file`,
    data: filePath,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
